module.exports = (node, isRequired = false, isValid, warningText = 'Required') => {
	let requiredTextNode = null
	function createRequiredTextNode(warningText) {
		if (!warningText) {
			requiredTextNode?.remove()
			return
		}
		if (requiredTextNode) {
			return requiredTextNode
		}
		const requiredText = document.createElement('small')
		requiredText.classList.add('text-danger')
		requiredText.classList.add('d-print-none')
		requiredText.innerHTML = warningText
		requiredText.id = `${node.id }-required-text`
		// When used on one of our input/select components, this should always put it inside the label element.
		node.parentNode.firstElementChild.appendChild(requiredText)
		return requiredText
	}

	const checkIsValid = isValid => isValid === undefined ? node.value !== '' : isValid

	if (isRequired && !checkIsValid(isValid)) {
		node.classList.add('border-danger')
		requiredTextNode = createRequiredTextNode(warningText)
	}
	return {
		teardown() {
			node.classList.remove('border-danger')
			requiredTextNode?.remove()
			requiredTextNode = null
		},
		update(isRequired, isValid, warningText) {
			if (isRequired && !checkIsValid(isValid)) {
				requiredTextNode = createRequiredTextNode(warningText)
				node.classList.add('border-danger')
			} else {
				node.classList.remove('border-danger')
				requiredTextNode?.remove()
				requiredTextNode = null
			}
		},
	}
}
